import { z, isoZ } from 'my-zod'

import { Frequency, RRule } from 'rrule'
import { ActionPlanOwnerTypeEnum, ActionPlanTriggerTypeEnum } from './action-plan-enums'

const recurrencePattern = z
  .string()
  .refine((s) => {
    const rrule = RRule.fromString(s)
    if (![Frequency.DAILY, Frequency.WEEKLY, Frequency.MONTHLY, Frequency.YEARLY].includes(rrule.options.freq)) {
      return false
    } else {
      return true
    }
  }, 'Invalid recurrence pattern value of action plan manual trigger. Freq value should be one of DAILY, WEEKLY, MONTHLY, YEARLY')
  .refine((s) => {
    const rrule = RRule.fromString(s)
    console.log(rrule.options)
    if (typeof rrule.options.interval === 'number' && rrule.options.interval < 1) {
      return false
    } else {
      return true
    }
  }, 'Recurrence cannot have interval less than 1')
  .refine((s) => {
    const rrule = RRule.fromString(s)
    if (typeof rrule.options.count === 'number' && rrule.options.count < 1) {
      return false
    } else {
      return true
    }
  }, 'Recurrence cannot have count less than 1')

const TriggerBase = z.object({
  id: z.number(),
  actionPlanTemplateId: z.number(),
  creatingUserId: z.number(),
  triggerType: ActionPlanTriggerTypeEnum,
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

const ManualTriggerMixin = z.object({
  triggerType: z.literal(ActionPlanTriggerTypeEnum.Enum.Manual),
  startDate: isoZ.date(),
  recurrencePattern: recurrencePattern.nullable(),
  userIds: z.number().array().nonempty().setLabel('Users')
})

const ManualWithOutfittersMixin = z.object({
  triggerType: z.literal(ActionPlanTriggerTypeEnum.Enum.ManualWithOutfitters),
  ownerType: ActionPlanOwnerTypeEnum.setLabel('Owner Type'),
  startDate: isoZ.date(),
  recurrencePattern: recurrencePattern.nullable(),
  userId: z.number().nullable().setLabel('User'),
  outfitterIds: z.number().array().nonempty()
})

const Manual = TriggerBase.merge(ManualTriggerMixin).strip()
const ManualWithOutfitters = TriggerBase.merge(ManualWithOutfittersMixin)
  .strip()
  .setCFV({
    ownerTypeRequired(trigger) {
      if (!trigger.ownerType) {
        return {
          path: ['ownerType'],
          message: 'Required *'
        }
      }
    },
    userIdRequiredForOwnerTypeUser(trigger) {
      if (trigger.ownerType === 'User' && !trigger.userId) {
        return {
          path: ['userId'],
          message: 'userId should be filled if owner type is User'
        }
      } else if (trigger.ownerType !== 'User' && trigger.userId) {
        return {
          path: ['userId'],
          message: 'userId should not be filled if owner type is Role'
        }
      }
    }
  })
const TriggerUnion = z.union([Manual, ManualWithOutfitters])

export const ActionPlanTriggers = {
  TriggerBase,
  ManualTriggerMixin,
  ManualWithOutfittersMixin,
  ManualWithOutfitters,
  Manual,
  TriggerUnion
}

export type ActionPlanTriggers = {
  [key in keyof typeof ActionPlanTriggers]: z.infer<(typeof ActionPlanTriggers)[key]>
}
